/* eslint-disable camelcase */
// 9fbef606107a605d69c0edbcd8029e5d
/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import dynamic from 'next/dynamic';
import placeholder from '@tcp/core/src/components/common/molecules/Placeholder';
import divisionTabs from '@tcp/core/src/components/common/molecules/HelpTabs';
import accordion from '@tcp/core/src/components/common/molecules/AccordionModule';
import ModuleX from '@tcp/core/src/components/common/molecules/ModuleX';
import Row from '@tcp/core/src/components/common/atoms/Row';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BreadCrumb from '@tcp/web/src/components/features/helpCenter/HelpCenterNew/atom/BreadCrumb/view';
import HELPCENTER_CONSTANTS from '@tcp/web/src/components/features/helpCenter/HelpCenterNew/HelpCenterNew.constants';
import AIAssistant from '@tcp/core/src/components/features/content/AIAssistant';
import throttle from 'lodash/throttle';
import withStyles from '../../../hoc/withStyles';
import errorBoundary from '../../../hoc/withErrorBoundary';
import style from '../styles/HelpCenterModuleTwoColNew.style';
import module_container from '../../ModuleContainer';
import { breakpoints } from '../../../../../../styles/themes/TCP/mediaQuery';

const TrackOrder = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "TrackOrder" */ '@tcp/web/src/components/features/helpCenter/TrackOrder'
  )
);

const moduleX = ModuleX;
const modules = { placeholder, divisionTabs, accordion, moduleX, module_container };

const createAccordionMap = (accMap, accordionData) => {
  if (accordionData) {
    accordionData.accordionWrapper?.forEach((acc) => {
      if (!acc?.text?.text) return;
      // eslint-disable-next-line no-param-reassign
      accMap[acc.text.text.toLowerCase()] = {
        richText: { ...acc.richText },
        name: acc.styled?.text,
        l3pageName: acc.text.text.toLowerCase(),
      };
    });
  }
};

const getViewportInfoHelpCenter = () => {
  const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const isMobile = width < parseInt(breakpoints.medium, 10);

  return {
    width,
    isMobile,
  };
};
const renderModuleContainers = (
  slotData,
  placeholderRendered = false,
  isHelpCenterHomePage,
  selectedAccordionIndex,
  setSelectedAccordionIndex,
  isMobile,
  breadCrumbData,
  others
) => {
  const { selectedPage } = others;
  const moduleContainers = slotData?.map((slotDatum, i) => {
    const Module = modules[slotDatum?.moduleName];
    if (i === 0 && isHelpCenterHomePage)
      return (
        <Module
          halfWidth
          {...slotDatum}
          {...others}
          helpCenterModuleContainer={true}
          firstModuleContainer={true}
          selectedAccordionIndex={selectedAccordionIndex}
          setSelectedAccordionIndex={setSelectedAccordionIndex}
          accordionIndex={i}
          isMobile={isMobile}
          isHelpCenterHomePage={isHelpCenterHomePage}
          key={`${selectedPage}_0`}
        />
      );
    return (
      <>
        <Module
          halfWidth
          {...slotDatum}
          {...others}
          selectedAccordionIndex={selectedAccordionIndex}
          setSelectedAccordionIndex={setSelectedAccordionIndex}
          accordionIndex={i}
          helpCenterModuleContainer={true}
          isMobile={isMobile}
          isHelpCenterHomePage={isHelpCenterHomePage}
          key={`${selectedPage}_${i}`}
        />
      </>
    );
  });

  const largeColSize = 9;
  const colOffset = { large: 1, small: 0, medium: 0 };
  return (
    <>
      <Col
        className="module_container_column"
        colSize={{
          small: 6,
          medium: placeholderRendered ? 8 : 6,
          large: largeColSize,
        }}
        offsetRight={colOffset}
      >
        <AIAssistant />
        {!isHelpCenterHomePage && (
          <BodyCopy className={'help-center__header-text'} component={'h2'} tabIndex={0}>
            {breadCrumbData[breadCrumbData?.length - 1]?.name}
          </BodyCopy>
        )}
        {moduleContainers}
      </Col>
      {isHelpCenterHomePage && isMobile && (
        <>
          <TrackOrder isMobile={isMobile} isCustomerServiceEnable={true} />
        </>
      )}
    </>
  );
};

function DynamicColumns(properties) {
  const {
    slot,
    selectedAccordionIndex,
    setSelectedAccordionIndex,
    isMobile,
    isHelpCenterL2Page,
    isHelpCenterL3Page,
    l3pageName,
    isHelpCenterHomePage,
    helpCenterSlots,
    breadCrumbData,
    ...others
  } = properties;

  const renderPlaceholder = (slotData) => {
    const Module = modules[slotData?.moduleName];
    return (
      <Col
        colSize={{
          small: 6,
          medium: 8,
          large: 3,
        }}
      >
        <Module halfWidth {...slotData} {...others} />
      </Col>
    );
  };

  const placeHolder = slot?.filter((currslot) => currslot?.moduleName === 'placeholder')[0];
  const firstModuleContainer = slot?.filter(
    (currslot) => currslot?.moduleName === 'module_container'
  )[0];
  const moduleContainers = [
    firstModuleContainer,
    ...helpCenterSlots
      ?.filter((currslot) => currslot?.moduleName === 'module_container')
      ?.map((moduleContainer) => moduleContainer?.data),
  ];

  const accordionSlots = helpCenterSlots?.filter(
    (currslot) => currslot?.moduleName === 'accordion'
  )?.[0]?.data;
  const accordionMap = {};

  if (isHelpCenterL3Page) createAccordionMap(accordionMap, accordionSlots);

  return (
    <>
      {placeHolder &&
        (!isHelpCenterHomePage || (isHelpCenterHomePage && isMobile)) &&
        renderPlaceholder(placeHolder)}
      {!isHelpCenterL3Page &&
        moduleContainers &&
        moduleContainers[0] &&
        renderModuleContainers(
          moduleContainers,
          !!placeHolder,
          isHelpCenterHomePage,
          selectedAccordionIndex,
          setSelectedAccordionIndex,
          isMobile,
          breadCrumbData,
          others
        )}

      {isHelpCenterHomePage && !isMobile && (
        <Col
          className="module_container_column"
          colSize={{
            small: 0,
            medium: 2,
            large: 3,
          }}
        >
          <TrackOrder isMobile={isMobile} isCustomerServiceEnable={true} />
        </Col>
      )}
      {isHelpCenterL3Page &&
        l3pageName &&
        accordionMap?.[l3pageName.toLowerCase()]?.richText?.text && (
          <Col
            className="module_container_column"
            colSize={{
              small: 6,
              medium: 8,
              large: 9,
            }}
            offsetRight={{ large: 1, small: 0, medium: 0 }}
          >
            {!isHelpCenterHomePage && (
              <BodyCopy className={'help-center__header-text'} component={'h2'} tabIndex={0}>
                {breadCrumbData[breadCrumbData?.length - 1]?.name}
              </BodyCopy>
            )}
            <ModuleX
              richTextList={[{ text: accordionMap[l3pageName.toLowerCase()]?.richText?.text }]}
            />
          </Col>
        )}
    </>
  );
}

const HelpCenterModuleTwoCol = (props) => {
  const {
    className,
    helpCenterSlots,
    pageName,
    selectedPage,
    isHelpCenterL3Page,
    isHelpCenterL2Page,
    l3pageName,
    isHelpCenterHomePage,
    handleHelpCenterStyle,
  } = props;
  const [selectedAccordionIndex, setSelectedAccordionIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(getViewportInfoHelpCenter().isMobile);

    const handleResize = throttle(() => {
      handleHelpCenterStyle();
      setIsMobile(getViewportInfoHelpCenter().isMobile);
    }, 500);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    handleHelpCenterStyle();
  }, [
    selectedPage,
    isHelpCenterL3Page,
    isHelpCenterHomePage,
    isHelpCenterL2Page,
    l3pageName,
    helpCenterSlots,
  ]);

  const createBreadCrumbData = () => {
    const breadCrumbData = [
      {
        name: 'Help Center',
        path: `/${HELPCENTER_CONSTANTS.HELP_CENTER_HOME_PATH}`,
        to: `/${HELPCENTER_CONSTANTS.HELP_CENTER_PAGE_PREFIX_NEW}?pageName=${HELPCENTER_CONSTANTS.HELP_CENTER_ROUTES.HOME}&${HELPCENTER_CONSTANTS.HELP_CENTER_ROUTES.HOME}`,
      },
    ];
    const accordionSlots = helpCenterSlots?.filter(
      (currslot) => currslot?.moduleName === 'accordion'
    )?.[0]?.data;
    const module2cols = helpCenterSlots?.filter((slot) => slot.moduleName === 'module2columns')[0];
    const l2navigationData = module2cols?.data?.slot?.filter(
      (slot) => slot.moduleName === 'placeholder'
    )?.[0]?.['help-center-left-navigation'];
    const l2NavData = l2navigationData?.filter(
      (navdata) => navdata?.leafLink?.url === `/${pageName}/${selectedPage}`
    )[0];
    breadCrumbData.push({
      name: l2NavData?.leafLink?.text,
      path: `${l2NavData?.leafLink.url}`,
      to: `/${pageName}?pageName=${selectedPage}&${selectedPage}`,
    });
    if (isHelpCenterL3Page && accordionSlots) {
      accordionSlots.accordionWrapper?.forEach((acc) => {
        if (!acc?.text?.text) return;
        if (acc?.text?.text?.toLowerCase() === l3pageName?.toLowerCase()) {
          breadCrumbData.push({
            name: acc.styled?.text,
            path: `/${pageName}/${selectedPage}/${l3pageName}`,
            to: `/${pageName}?pageName=${selectedPage}&l3pageName=${l3pageName}`,
          });
        }
      });
    }
    return breadCrumbData;
  };
  const breadCrumbData = createBreadCrumbData();
  return (
    <>
      {!isHelpCenterHomePage && (
        <BreadCrumb
          selectedPage={selectedPage}
          pageName={pageName}
          breadCrumbData={breadCrumbData}
          isHeaderRequired={false}
        />
      )}
      <Row className={`${className} helpCenterModuleTwoCol`}>
        <DynamicColumns
          breadCrumbData={breadCrumbData}
          {...props}
          selectedAccordionIndex={selectedAccordionIndex}
          setSelectedAccordionIndex={setSelectedAccordionIndex}
          isMobile={isMobile}
        />
      </Row>
    </>
  );
};

HelpCenterModuleTwoCol.propTypes = {
  className: PropTypes.string.isRequired,
};
export default withStyles(errorBoundary(HelpCenterModuleTwoCol), style);
export { HelpCenterModuleTwoCol as HelpCenterModuleTwoColVanilla };
